/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

/**
 * <p>Represents a type of spinner context.
 * @default UNKNOWN
 */
export enum SpinnerContextTypeEnum {
    /**
     * <p>Unknown context type.
     */
    UNKNOWN = '',
    /**
     * <p>Local context type.
     */
    LOCAL = 'LOCAL',
    /**
     * <p>Global context type.
     */
    GLOBAL = 'GLOBAL'
}
